const methods = {
  format: (nomeUnidade, siglaUnidade) => {
    if (siglaUnidade !== null) {
      return nomeUnidade.concat(' - ', siglaUnidade)
    } else {
      return nomeUnidade
    }
  }
}

export default methods



// WEBPACK FOOTER //
// ./src/utils/unidade.js